/**
 * The onboarding stepper (mission 9 WP12 T073; sheet 08 callout 1; A.1, A.4, B.1; FR-013; squad U23;
 * research §1.28; style guide §7.9).
 *
 * Create account · Two-step sign-in · Verify · Subscribe, in the order the sign-up flow runs them (U23):
 * steps 1 to 3 are done by the time a tenant reaches this page (sheets 06 and 07), and Subscribe is
 * current (`aria-current="step"`). The nodes follow §7.9: done is a navy fill with a white check, current
 * a white node in a Sky-burst ring. Its centre dot is navy, not Sky-burst: the style-guide job allows a
 * Sky-burst fill only on the progress bar and the run stepper (T6). Labels are 13/500.
 */
import { Check } from 'lucide-react'

import { cn } from '@/components/ui/cn'
import { copyText, type TextKey } from '@/lib/provisional-copy'

const STEPS: readonly TextKey[] = ['stepperAccount', 'stepperSecure', 'stepperVerify', 'stepperSubscribe']

/** The step this page is: the last one. */
const CURRENT = STEPS.length - 1

export function OnboardingStepper() {
  return (
    <ol data-onboarding-stepper="" className="flex items-start">
      {STEPS.map((key, i) => {
        const done = i < CURRENT
        const last = i === CURRENT
        return (
          <li
            key={key}
            data-node-state={done ? 'done' : 'current'}
            aria-current={done ? undefined : 'step'}
            className={cn('flex items-start', !last && 'flex-1')}
          >
            <div className="flex flex-col items-center gap-1.5">
              {done ? (
                <span className="flex size-6 items-center justify-center rounded-full bg-navy-950 text-white">
                  <Check aria-hidden className="size-3.5" />
                </span>
              ) : (
                <span className="flex size-6 items-center justify-center rounded-full bg-white [box-shadow:0_0_0_2px_var(--color-accent)]">
                  <span aria-hidden className="size-2 rounded-full bg-navy-950" />
                </span>
              )}
              <span className={cn('text-[13px] font-medium leading-[18px]', done ? 'text-navy-600' : 'text-navy-950')}>
                {copyText(key)}
              </span>
            </div>
            {last ? null : <span aria-hidden className="mx-2 mt-[11px] h-0 flex-1 border-t-2 border-navy-950" />}
          </li>
        )
      })}
    </ol>
  )
}
